export const useAgreement = () => {
    const agreeContent = {
        privacy: {
            title: "隐私政策",
            render: () => {
                return (<p class="content">
            秉持用户隐私至上，用户信息安全至上的理念，鸿博股份有限公司及子公司北京英博数科科技有限公司(以下简称“英博云”、“我们”)
            矢志为全球用户提供高品质可信赖的算力云服务。本隐私保护政策旨在向您说明英博云在提供本网站服务、云服务或产品时如何收集、使用、存储、删除您的个人信息，并提示您所享有的个人信息权利。英博云非常重视您的隐私，我们将采取一切措施保护您的隐私和个人信息权益。
            如您在英博云网站(
            <a class="aStyle cursor" href="https://cloud.ebtech.com/">
              https://cloud.ebtech.com/
            </a>
            )
            上注册账户，使用控制台，或购买云计算产品与服务，本隐私政策将予以适用。特别地，我们会针对特定的产品或服务制定有针对性的隐私政策。
            如我们的服务可能包含指向第三方网站、应用程序或服务的链接，本政策不适用于第三方提供的任何产品、服务、网站或内容。如您的公司等经营实体借助我们的产品或服务为您的客户提供服务，您需要制定符合交易场景的个人信息保护政策。
            英博云温馨提示您，在使用英博云提供的各项产品与服务前，请仔细阅读并理解本《隐私政策》(以下简称“政策”)
            。<div class="title m-10">本政策目录：</div>
            <div>1.我们收集哪些个人信息？</div>
            <div>2.我们收集您的个人信息的目的？</div>
            <div> 3.我们使用哪些Cookies？</div>
            <div>4.我们如何存储、共享、转让、披露您的个人信息？</div>
            <div>
              5.我们如何保护您的个人信息安全？ 6.您享有何种个人信息权利？
            </div>
            <div>7.我们如何保护未成年人的个人信息？</div>
            <div>8.您的信息如何进行国际传输？</div>
            <div>9.本政策如何更新？</div>
            <div>10.怎样联系我们？</div>
            <div class="title m-10">1.我们收集哪些个人信息？</div>
            <div>
              1.1个人信息是指以电子或者其他方式记录的与已识别或可识别的自然人有关的各种信息。
            </div>
            <div class="title">
              1.2 当您经由英博云网站(尤其是通过登录控制台)
              购买、使用英博云的产品和服务时，我们会收集并使用您的如下个人信息：
            </div>
            <span class="title">(1) 注册信息。</span>
            当您在英博云注册账号时，您需向我们提供
            <span class="title">用户名、手机号码</span>
            ，并创建密码。您提交的手机号码用于您注册、绑定账户、接收验证码(如找回密码)
            ，并作为您指定的用来接收相关业务通知(如新品上线、活动提醒、服务变更、服务相关通知等)
            的联系方式。
            在您注册完毕后，您可以选择在控制台上继续完善您的信息，包括但不限于：您的真实姓名、所属行业、所在地区、网址、详细地址和邮箱。
            如您不进行注册，您可以继续浏览英博云对外公开展示的网页页面或产品介绍，但您无法获得英博云提供的进一步服务。
            <div>
              <span class="title">(2) 认证信息。</span>
              依据《中华人民共和国网络安全法》的规定，在购买和使用英博云产品、服务之前，您需要完成实名认证。在实名认证阶段，您需要进一步完善包括但不限于您的
              <span class="title">
                姓名、身份证明文件信息(身份证或护照类信息)
                、面部信息、银行卡号信息
              </span>
              用于验证您的真实身份，我们可能会通过第三方(百度)
              提供的服务验证实名认证信息。
              <span class="title">
                面部信息和银行卡号信息属于个人敏感信息，您可以拒绝提供，但如果您拒绝提供您将无法完成实名认证流程。
              </span>
              如您不进行实名认证，不会影响您浏览英博云网页页面或产品介绍，但您将无法购买英博云的产品和服务。
              <span class="title">
                但是，如果您来自中华人民共和国大陆地区以外的其他国家或地区，在注册时您通常只需提供您的电子邮箱信息。除非您自己选择通过电话号码注册，否则我们不会收集您的电话号码等信息。
              </span>
            </div>
            <div>
              <span class="title">(3) 备案服务信息。</span>
              当您使用英博云特定业务功能(如备案服务)
              时，为遵守国家相关规定并满足向您提供该产品和服务之目的，除注册信息和实名认证信息中已包含的信息类型外，您还需要进一步向我们提供包括但不限于您的企业或网站负责人
              <span class="title">
                姓名、身份证、手机号码、邮箱、域名证书、备案照片
              </span>
              等，如果您不提供上述信息，您将无法使用特定业务功能，但不影响您对基本产品和服务的使用。
            </div>
            <div>
              <span class="title">(4) 日志信息。</span>
              出于为您提供服务并监控云服务运行状态的必要，我们会收集您的
              <span class="title">ID、IP地址</span>
              、浏览器的类型、使用的语言、硬件设备信息、操作系统的版本、网络运营商的信息、您访问服务的日期、时间以及时长等信息。
            </div>
            <div>
              <span class="title">(5) 客户服务信息。</span>
              当您需要使用英博云客户服务时，您需要提供
              <span class="title">UID、用户名</span>
              或是其他可以核实您身份的信息，以便我们响应您的服务请求。同时您还需要提供您的
              <span class="title">姓氏、手机号</span>
              ，以便我们及时对您提出的服务请求进行反馈。我们可能会保留您的聊天记录、订单信息，以便向您提供您希望获得的各项服务。
              在您新建消息接收人时，您需要提供消息接收人的姓名、邮箱、手机号码。
            </div>
            <div>
              <span class="title">(6) 运营及支持信息。</span>
              英博云会不时针对新推出的服务和功能组织运营活动，如果您参加相关运营活动，我们可能会通过运营活动界面收集您的联系方式(例如手机号)
              、联系地址和交易账号类信息，以便您能成功参与活动。若您不参加相关运营活动则无需提供前述信息。
            </div>
            <div>
              <span class="title">(7) 付款信息。</span>
              基于支付服务费用的需要，您可能需要提供支付信息(如微信、支付宝或银行卡等信息)
              、增值税编号和税务识别号，这具体取决于您与英博云的服务协议中规定的支付方式。为完成交易，我们可能会与第三方银行共享您的姓名与银行卡号，以完成收款。
            </div>
            <div>
              <span class="title">(8) 发票收件信息。</span>
              基于寄送发票的需要，我们可能需要您提供
              <span class="title">收件人姓名、收件电话、地区、地址和邮编</span>
              等信息。
            </div>
            <div>
              <span class="title">(9) 其他信息。</span>
              英博云收集您在使用我们的服务过程中授权收集或提供的其他个人信息，在英博云收集之前，我们将首先征求您的同意。
            </div>
            <div class="title m-10">2.我们收集您的个人信息的目的？</div>
            英博云收集您的个人信息，将用于以下用途。
            <span class="title">
              当我们要将收集到的信息用于本政策未载明的其他用途时，会事先征求您的同意和授权。
            </span>
            <div>(1) 向您提供、维护、改进产品或服务； </div>
            <div>
              (2) 向您发送关于系统安全、产品或服务变化等方面的重要通知；
            </div>
            <div>(3) 激活或验证产品或服务；</div>
            <div>
              (4)
              在法律法规允许的前提下向您推广、介绍产品；您有权选择退出，具体请参阅本隐私政策第6.10节；
            </div>
            <div>(5) 为您提供个性化产品、服务或个性化用户体验； </div>
            <div>
              (6)
              开展内部审计、数据分析和研究，以改善我们的产品和服务；您在自动化个人决策和用户画像方面的权利，请进一步参阅本隐私政策中的6.7条；
            </div>
            <div>(7) 保护我们产品、服务和用户的信息技术安全； </div>
            <div>
              (8)
              遵从和执行适用的法律要求或相关的行业标准，如法律有关于实名认证的规定，所收集的包括银行卡号在内的信息都只用于实名认证用途，而不会用于其他目的；
            </div>
            <div>
              (9) 经您许可的其他用途。
              如您对数据处理用途有疑义，或希望我们停止其中一种或多种数据使用方式，请与客服团队联系。
            </div>
            <div class="title m-10">3.我们使用哪些Cookies？</div>
            <div>
              3.1为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookies的小数据文件。Cookies
              通常包含标识符、站点名称以及一些号码和字符。英博云只能读取英博云提供的Cookies。
            </div>
            <div>
              3.2 我们启用Cookies的目的与大多数网站或互联网服务提供商启用
              Cookies 的目的一样，即改善用户体验。具体而言，有以下目的：
            </div>
            <div>
              (1)
              借助于Cookies，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。
            </div>
            <div>
              (2)
              认证。当您访问英博云网站时，我们会为您生成一个单独的ID，以标识您的身份。如果网站不使用具有该功能的
              Cookies，那么在用户每一次打开网页时，该网站都会将其视为新访客。
            </div>
            <div>
              (3)
              统计分析。例如我们使用Cookies以统计用户访问数量，以及了解您的访问来源。
            </div>
            <div> (4) 安全。我们使用Cookies保障网站运作安全。 </div>
            <div>
              3.3 我们不会将 Cookies
              用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
              Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器都设有阻止
              Cookies
              的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
            </div>
            <div>
              3.4
              请参阅我们的Cookies政策，以获取有关我们处理Cookies的法规和实践的更多信息。
            </div>
            <div class="title m-10">
              4.我们如何存储、共享、转让、披露您的个人信息？
            </div>
            <div class="title m-10">4.1 存储</div>
            在法律规定的保留期或合同约定的保留期间内，英博云将存储关于您的个人信息，以使您能够顺畅使用我们的产品和服务。
            <span class="title">
              在法律规定的保留期或合同约定的保留期间结束后，我们将对您的个人信息进行删除、匿名化或去标识化处理。
            </span>
            <div class="title">
              根据您与英博云产品交互的范围，您的个人信息可能存储在依据用户协议确定的国家或地区。如我们将您的个人信息存储地点从中国境内转移到境外，将征询您的同意，并确保遵循本隐私政策以及相关个人信息保护法。
            </div>
            但在下列情况下，且仅出于下列情况相关的目的，我们有可能需要较长时间保留您的信息或部分信息：
            <div>(1) 基于遵守法律法规的需要。</div>
            <div>(2) 遵守法院判决、裁定或其他法律程序的要求。</div>
            <div>(3) 遵守相关政府机构或其他有权机构的要求。</div>
            <div>(4) 我们有理由确信需遵守法律法规等有关规定。</div>
            <div>
              (5)
              为执行相关服务协议或本隐私声明，维护社会公共利益，处理投诉/纠纷，保护我们或我们的关联公司的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
            </div>
            <div>
              <div class="title m-10">4.2 共享</div>
              <span class="title">
                我们不会与英博云以外的任何公司、组织或个人分享您的个人信息，
                但以下情况除外：
              </span>
            </div>
            <div>
              (1)
              在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
            </div>
            <div>
              (2)
              我们可能会根据法律法规规定，诉讼、仲裁解决需要，或按行政、司法机构依法提出的要求，对外共享您的用户信息。
            </div>
            <div>
              (3)
              与我们的关联方共享：您的个人信息可能会与英博云的关联公司共享。我们只会共享提供服务所必要的个人信息，且受本隐私政策中所声明目的的约束。关联方如欲改变个人信息的处理目的，将再次征求您的授权同意。
              一方控制、共同控制另一方或对另一方施加重大影响，以及两方或两方以上同受一方控制、共同控制或重大影响的，构成关联方。控制，是指有权决定一个企业的财务和经营政策，并能据以从该企业的经营活动中获取利益。共同控制，是指按照合同约定对某项经济活动所共有的控制，仅在与该项经济活动相关的重要财务和经营决策需要分享控制权的投资方一致同意时存在。重大影响，是指对一个企业的财务和经营政策有参与决策的权力，但并不能够控制或者与其他方一起共同控制这些政策的制定。
            </div>
            <div>
              (4)
              与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务，如实名验证将由授权合作伙伴提供。我们仅会出于合法、正当、必要、特定、明确的目的使用您的个人信息，并且只会提供服务所必要的个人信息。我们的合作伙伴无权将获得的个人信息用于任何其他用途。对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密条款及数据处理协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理用户信息。此外，您的个人信息将通过基础网络运营商传输到数据中心的存储空间内。我们在中国的服务将使用中国的基础网络运营商及位于中国境内的数据中心。
              在这种情况下，这些公司(包括英博云的附属公司、合作伙伴和任何其他实体)
              将同样遵守我们的数据隐私和安全要求，不会将从我们接收的个人数据用于任何其他目的。
              随着业务的发展，英博云可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的控制者继续保护您的个人信息。
            </div>
            <div>
              <div class="title m-10">4.3 转让</div>
              <span class="title">
                我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
              </span>
            </div>
            <div>
              (1)
              在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
            </div>
            <div>(2) 基于您自行提出的要求。 </div>
            <div>
              (3)
              在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求拟持有您个人信息的第三方公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
              关于我们跨境传输政策的更多信息，请您参阅本政策中的“您的个人信息如何进行国际传输？”
            </div>
            <div>
              <div class="title m-10">4.4 信息披露</div>
              <span class="title">
                我们仅会在以下情况下，向有关部门披露您的个人信息：
              </span>
            </div>
            <div>
              (1)
              基于明示同意的披露：获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息。
            </div>
            <div>
              (2)
              基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
            </div>
            <div>
              <div class="title m-10">4.5 关于授权同意的例外</div>
              在以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：
            </div>
            <div>1) 为与您签订、履行合同所必需的；</div>
            <div>2) 为履行法定职责或者法定义务所必需的；</div>
            <div>
              3)
              为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需的；
            </div>
            <div>
              4)
              为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
            </div>
            <div>
              5)
              所涉及的个人信息是您自行向社会公众公开的或者其他已经合法公开的信息中收集个人信息并在合理范围内处理的；
            </div>
            <div>6) 法律、行政法规规定的其他情形。</div>
            <div class="title m-10">5.我们如何保护您的个人信息安全？ </div>
            <div>
              5.1
              英博云非常重视您的信息安全。我们努力采取各种合理的技术和管理方面的安全措施来保护您的用户信息，防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。未经您允许，我们不会访问您的任何业务数据。
              我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对保护用户信息重要性的认识。
            </div>
            <div>
              5.2
              我们会采取一切合理可行的措施，尽量避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律另有规定或您的要求需要延长保留期。基于不同的场景、产品及服务，数据的存储期可能会有所不同，我们用于确定存留期的标准包括：完成该业务目的需要留存个人数据的时间，包括提供产品和服务，依据法律要求维护相应的交易及业务记录，保证系统、产品和服务的安全，应对可能的用户查询或投诉、问题定位等；用户是否同意更长的留存期间；法律、合同等是否有保留数据的特殊要求等。超出上述用户信息保存期限后，我们会对您的个人信息进行删除、匿名化或去标识化处理。
            </div>
            <div>
              5.3
              为更有效的保障您的信息安全，我们也希望您能够加强自我保护意识，请您妥善保管您的账号及密码信息，避免您的个人信息泄露。我们仅在英博云直接导致您个人信息泄露的范围内承担责任，如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
            </div>
            <div>
              5.4
              互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件(泄露、篡改、丢失等)
              后，我们将按照有关法律法规的要求，及时向您告知以下信息：发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害、安全事件的基本情况和可能的影响，我们已采取或将要采取的处置措施，您可自主防范和降低风险的建议，对您的补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监督部门要求，主动上报个人信息安全事件的处置情况。
            </div>
            <div class="title m-10">6.您享有何种个人信息权利？</div>
            <div>
              英博云的客户来自世界各地，所以我们会严格遵守客户所在国的法律规定，竭力保护客户的各项个人信息权利。例如，我们严格遵守《中华人民共和国民法典》、《中华人民共和国个人信息保护法》、新加坡《个人信息保护法》(PDPA)
              、欧盟《个人信息保护一般条例》(GDPR)
              、《加州消费者隐私法案》(CCPA) 等法律与规定。
              在适用条件满足时，您将享有以下权利：
            </div>
            <div>
              <div class="title m-10">6.1 不同意或撤销同意的权利</div>
              作为一项原则，我们将在收集关于您的信息前事先获得您的同意与授权。如您不同意收集信息的行为，或您认为有必要撤销同意，我们将不会继续收集您的个人信息。不过，这不影响您撤销同意与授权前的信息收集行为的合法性。
            </div>
            <div>
              <div class="title m-10">6.2 查阅、复制权</div>
              除法律法规规定的例外情况外，您可以通过登录网站账号安全管理页面，查阅、复制我们持有的关于您的个人信息，行使该权利有困难的，您也可以通过本政策提供的联系方式，将相关申请提交给我们。
            </div>
            <div>
              <div class="title m-10">6.3 更正权</div>
              如您发现您提供的个人信息有错误或不完整，您有权对个人信息进行更新或更正。
            </div>
            <div class="title m-10">6.4 删除权 </div>
            <div>您有权要求我们删除所收集的关于您的信息。例如：</div>
            <div>(1) 处理目的已实现、无法实现或者为实现处理目的不再必要；</div>
            <div>(2) 英博云停止提供产品或者服务，或者保存期限已届满；</div>
            <div>
              (3) 您撤回同意； (4) 违反法律、行政法规或者违反约定处理个人信息；
            </div>
            <div>
              (5) 法律、行政法规规定的其他情形。
              依照我们与您的合同约定，不再有保存您的个人信息的必要性；
              当您自行注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求对您的个人信息进行删除、匿名化或去标识化处理。
            </div>
            <div>
              <div class="title  m-10">6.5 拒绝处理个人信息的权利</div>
              您有权要求我们停止处理您的个人信息或停止向您发送营销信息。
            </div>
            <div>
              <div class="title  m-10">6.6 限制处理个人信息的权利</div>
              您有权在某些情况下要求我们限制处理您的个人信息。例如，您认为我们所保留的关于您的个人信息不准确或不合法。
            </div>
            <div>
              <div class="title m-10">
                6.7 关于自动化个人决策与用户画像的权利
              </div>
              当我们采取自动化个人决策技术或进行用户画像时，我们将事先征得您的同意或在合同中与您进行约定。如果这些决策显著影响您的合法权益，请您通过本政策第10条提供的联系方式联系我们。
            </div>
            <div>
              <div class="title m-10">6.8 可携权</div>
              在符合法律法规和国家网信部门规定且技术可行的前提下，我们将根据您的要求将您自己提供的以及根据合同或同意收集的个人信息转移至指定的个人信息处理者。
            </div>
            <div>
              <div class="title m-10">6.9 选择退出的权利</div>
              如果您是一名加州居民，我们将根据《加州消费者隐私法案》(CCPA)
              处理您的个人信息。我们不出售您的个人信息。因此，我们不提供拒绝出售个人信息的选择。但是，我们为您提供了反对或限制处理个人信息的权利，以确保您的基本权利。
              <div class="title m-10">7.我们如何保护未成年人的个人信息？</div>
            </div>
            <div>
              7.1
              我们主要面向企业或成年人提供产品和服务。如您为不满十四周岁的未成年人，您需要请您的父母或监护人仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的产品与服务或向我们提供信息。
            </div>
            <div>
              7.2
              如经父母或监护人同意使用我们的产品或服务，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下收集、存储、使用、共享或删除不满十四周岁未成年人的信息。
            </div>
            <div class="title m-10">8.本政策如何更新？</div>
            <div>
              8.1 根据法律规定的修订或业务发展的变化，我们的隐私政策会定期更新。
            </div>
            <div> 8.2 我们会通过公司官网发布对本政策所做的任何变更。 </div>
            <div>
              8.3
              对于重大变更，我们还会提供更为显著的通知(包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容)
              。
            </div>
            <div> 8.4 本政策所指的重大变更包括但不限于： </div>
            <div>
              (1)
              我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
            </div>
            <div>
              (2)
              我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
            </div>
            <div>(3) 个人信息共享、转让或公开披露的主要对象发生变化； </div>
            <div>
              (4) 您参与个人信息处理方面的权利及其行使方式发生重大变化；
            </div>
            <div>
              (5)
              我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
            </div>
            <div>
              (6) 个人信息安全影响评估报告表明存在高风险时。
              我们强烈建议您随时访问我们的官方网站，查看隐私政策。在适用数据保护法律要求时，针对重大变更，我们还将重新取得您的同意。
            </div>
            <div class="title m-10">9.怎样联系我们？</div>
            <span class="title">
              如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过以下方式与我们联系：
            </span>
            <div>(1) 您可以通过英博云的联系客服入口和我们取得联系；</div>
            <div>
              (2) 您可以通过邮箱<span class="aStyle"> info@ebtech.com </span>
              与我们联系；
              我们将尽快审核所涉问题，并在验证您的用户身份后15个工作日内予以回复。如根据您请求的复杂度，需要延迟回复，我们会一并告知您延迟处理的原因和时间(通常为15个工作日)
              。
            </div>
          </p>);
            }
        },
        serve: {
            title: "服务条款",
            render: () => {
                return (<p class="content">
            <div class="title m-10">欢迎您使用 英博云 服务！</div>
            <div class="title m-10">
              本协议是 英博云与您，就您使用
              英博云服务的相关事项签订的合同。为使用 英博云
              服务，您应当充分阅读、理解本协议，其中限制、免责条款或者其他涉及您重大权益的条款(如违约处罚、争议管辖等)可能会以加粗、加下划线等形式提示您重点注意。
            </div>
            <div class="title m-10">
              除非您已充分阅读、理解并同意接受和遵守本协议，否则，请您不要使用
              英博云
              服务。您通过网页确认或以其他任何方式明示或者默示表示接受本协议，或您以任何方式使用
              英博云
              服务的，即视为您已阅读并同意接受本协议的约束，本协议即在您与
              英博云之间产生法律效力。
            </div>
            <div class="title m-10">
              使用 英博云 服务应当遵守本协议及其服务规则。服务规则以 英博云
              官网或其他相关页面展示的内容为准，您应事先了解服务规则，并根据服务规则进行操作，以确保顺利使用。
            </div>
            <div class="title m-10">第一条 通则</div>
            <div>
              1.1 英博云服务指 英博云
              提供的云服务器、云数据存储等各种产品、服务(具体以 英博云
              实际提供的为准)，您可以根据自己的需求选择使用一项或多项具体服务并遵守其服务规则。
            </div>
            <div>
              1.2
              涉及具体服务的服务内容、服务等级、技术规范、操作文档、计费标准等内容的服务条款、规则、说明、标准等(统称为“服务规则”)，以
              英博云 官网或其他相关页面展示的内容为准。
            </div>
            <div>
              1.3 英博云
              是中立的技术服务提供者，依约向您提供各类技术产品和服务；您的网站、应用、软件、平台等任何产品、服务及相关内容等，由您自行运营并承担全部责任。
            </div>
            <div>
              1.4
              双方均保证已经依照国家相关规定获得了合法经营资质或政府审批等，有权依法运营其产品及服务。双方进一步保证，在本协议有效期内持续保持具备国家相关规定要求的经营资质或审批手续。
            </div>
            <div class="title m-10">第二条 账号</div>
            <div>
              2.1 您应依法具备必要、适当的权利能力和行为能力，按照 英博云
              的要求完成注册、获得 英博云 服务账号(以下简称“账号”)。
            </div>
            <div>
              2.2
              为保护账号的安全性和独立性，避免出现账号归属不清晰等不良后果，您应当使用您享有合法权益的手机号进行注册或登录，否则，可能导致您无法正常登录和使用
              英博云 服务。
            </div>
            <div class="title">
              2.3 您应当按照 英博云
              服务流程填写、提交真实、合法、有效的资料(统称“客户资料”)，包括但不限于名称、联系人、电子邮箱、联系电话、联系地址、工商登记证件等；如果客户资料发生变更的，您应及时书面通知
              英博云 或根据 英博云 的规则自行进行更新。
            </div>
            <div class="title">
              2.4
              本协议效力适用于您名下全部账号以及主帐号下的子账号。账号将作为您使用
              英博云
              服务的身份识别依据，您应当对用户名、密码等信息采取必要、有效的保密和安全保护措施(包括但不限于：保管使用权限、设置高强度密码和定期更换措施等)，否则，导致的后果由您自行承担。此外，您应为账号下的行为负责，所有账号下的操作行为均被视为您实施，且应由您承担全部法律后果。
            </div>
            <div class="title">
              2.5
              若您发现有他人盗用您的账号及密码、或任何其他未经您合法授权的情形时，您应立即以有效方式通知
              英博云 并提供必要资料(如客户资料、情况说明、证明材料及诉求等，以便
              英博云 核实身份及事件)。 英博云
              收到您的有效通知并核实身份后，会依据法律法规及服务规则进行处理。
              英博云 依据本条进行处理产生的相关责任和后果由您承担。
            </div>
            <div class="title">
              若您提供的资料存在瑕疵，导致 英博云
              无法核实您的身份或无法判断您的需求等，而导致 英博云
              未能及时处理，给您带来的损失，应由您自行承担。同时，您理解，
              英博云 对您的请求进行处理需要合理期限，对于 英博云
              采取措施前您已经产生的损失以及采取措施后因不可归责于 英博云
              的原因导致的损失，英博云 不承担任何责任。
            </div>
            <div class="title m-10">第三条 服务</div>
            <div>3.1 服务开通 </div>
            <div>
              3.1.1 您可根据自身需求，自行通过 英博云
              官网在线选购所需服务，购买前您需仔细阅读所购服务对应的服务规则并根据自身需求决定是否购买或使用。双方也可根据实际合作需要，另行签订协议等。
            </div>
            <div>
              3.1.2 部分 英博云
              服务的开通可能需要双方另行签订单独的服务协议，单独的服务协议可能以电子文档形式展示，也可能是独立的纸质文档形式展示，您可以根据自身情况决定是否接受服务协议及开通服务。
            </div>
            <div>
              3.1.3
              您需在订单提交后及时完成支付。部分服务可能有时间限制、库存限制或者活动数量等限制，订单提交后，若发生您未及时付款、或付款期间出现数量不足或已达到限量等情况的，您将可能无法使用相关服务。
            </div>
            <div>
              3.1.4 英博云
              可能因营销活动、产品推广等各种原因，在特定时期内推出“限时免费”、“限时优惠”、“限量优惠”、“充值优惠”以及赠送服务等优惠措施(以下统称“优惠措施”)，您理解并同意，这些优惠措施可能是暂时性、阶段性或有数量限制的，也可能仅适用于满足特定条件的客户，您需要按照相应的规则购买、使用相应服务。除非另有书面明确说明，优惠措施不可同时叠加适用。
            </div>
            <div>3.2 服务费用</div>
            <div>
              3.2.1 英博云
              服务的结算方式可能分为预付费和后付费等类型，为保证服务及时开通或持续提供，您应当遵守本协议及您使用的服务的服务规则并及时缴纳费用。部分
              英博云
              服务开通后(例如云服务器、云存储等)，即使您未新增服务项目或资源，亦未进行新的操作，但由于该部分服务会持续占用资源，因此将持续产生扣费，您应当及时续费或关闭服务。
            </div>
            <div class="title">
              3.2.2
              优惠措施是基于特定条件设置，例如针对特定配置的产品的优惠措施、您需一次性使用特定期限或数量的产品方可享受的优惠措施等(如包月优惠)，若您最终未符合特定条件，则无法享受相应的优惠(包括但不限于折扣、代金券赠与等)，双方需按照购买时相应服务的官网原价进行费用结算。
            </div>
            <div class="title">
              3.2.3
              您可以通过账号在线付款或充值续费。或经双方协商一致后，通过银行转账方式向
              英博云
              支付费用(为保证服务的持续性，若您选择线下支付费用的，应预留合理时间以便
              英博云 核实到账情况并完成您账号充值)。
            </div>
            <div class="title">
              3.2.4 对于按自然月结算的服务，英博云
              向您提供上一月的缴费账单后，您须在5个工作日内予以核对确认或提出异议。如
              英博云
              未在5个工作日内收到您的确认或异议，视为您无异议；您如有异议，由双方友好协商解决，如协商不成以
              英博云 系统数据为准。
            </div>
            <div>
              3.2.5
              产品/服务在正常使用时优先使用代金券部分，后消耗实付金额。一旦发生退款事宜，则不能享受优惠政策，也无法享受充值所赠送的代金券/代金券。退款时，优先以实付金额抵扣消耗费用，抵扣后剩余的实付金额为实际退款金额。在英博云购买的所有产品/服务均不支持自助退款渠道，请您联系平台客服处理后续退款事宜。
            </div>
            <div>
              3.2.6
              本协议项下的业务发生销售折让、销售退回或其他按照国家规定需要开具红字发票或重新开票的情况，
              英博云
              需按照国家税收规定向您开具红字发票或重新开票，您需按照国家税收规定退回
              英博云 已开具的发票或向税局递交需 英博云
              开具红字专用发票的有效证明。
            </div>
            <div>3.3 服务支持</div>
            <div>
              3.3.1 英博云 向您提供售后服务，协助您解答、处理使用 英博云
              服务过程中遇到的问题。
            </div>
            <div>
              3.3.2 英博云
              将依照法律法规要求对其系统、设备等采取基础的安全保护措施。若您对安全保护措施的要求高于前述基础的安全保护措施标准的，您有权根据自身需求购买配置更高的安全保护服务或另行配置其他安全防护软件、系统等。
            </div>
            <div>
              3.3.3
              您应自行对您使用的计算机信息系统、设备等采取必要的、有效的安全保护措施，因您未采取前述措施导致权益受损的，由您自行承担责任。
            </div>
            <div>
              3.3.4 英博云
              在服务规则约定内提供可用性保障。如果您对可用性的要求高于服务规则，则需要您主动对自身系统进行高可用性的设置，
              英博云 可给与必要的协助。如果需要 英博云
              配合做设计，由双方另行协商确认。
            </div>
            <div>3.4 服务中止或终止</div>
            <div class="title">
              3.4.1 为了向您提供更加完善的服务， 英博云
              有权定期或不定期地对服务平台或相关设备、系统、软件等进行检修、维护、升级及优化等(统称“常规维护”)，如因常规维护造成
              英博云 服务在合理时间内中断或暂停的， 英博云
              无需为此向您承担责任。但是，英博云
              应当至少提前24小时，就常规维护事宜通知您。若因不可抗力、基础运营商过错等原因导致的非常规维护，
              英博云 应及时通知您。
            </div>
            <div class="title">
              3.4.2 为保证服务的安全性和稳定性， 英博云
              可能进行机房迁移、设备更换等重大调整，前述情况可能导致 英博云
              服务在合理时间内中断或暂停，英博云
              无需为此向您承担责任，但是，英博云
              应提前3天通知您，您应予以配合；如您不配合进行调整，或者 英博云
              无法与您取得联系，由此产生的后果由您自行承担。
            </div>
            <div class="title">
              3.4.3
              如您购买的具体服务含有存储功能的，在该服务到期或终止后，对于您存储在该服务中的数据等任何信息，
              英博云
              将根据该服务的服务规则为您保留相应期限。您应承担保留期限内产生的费用(若有)，并按时结清费用、完成全部数据的迁移。保留期限届满后，您的前述信息将被删除。
            </div>
            <div class="title">
              3.4.4 英博云
              有权根据自身运营安排，随时调整、终止部分或全部服务(包括但不限于对服务进行下线、迭代、整合等)。但是，
              英博云
              应提前至少3天通知您，以便您做好相关数据的转移备份以及业务调整等，以保护您的合法权益。
            </div>
            <div class="title">
              3.5
              基于网络服务的及时性、复杂性、高效性等特性及监管要求、政策调整等原因，您同意
              英博云 可以不时对本协议以及 英博云
              的相关服务规则进行调整，并通过网站公告、邮件通知、短信通知、系统消息、站内信等方式中的一种或多种予以公布；若您在调整后继续使用
              英博云
              服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的内容。
            </div>
            <div>
              3.6
              若您选择使用中国大陆以外的服务，应当确保您符合中国大陆法律法规、政策等的要求，同时，也应当确保您的资质、能力以及使用行为等均符合当地法律法规、政策等的要求。
            </div>
            <div class="title m-10">第四条 客户权利义务</div>
            <div>
              4.1 您有权依照本协议约定使用 英博云 服务并获得 英博云
              的技术支持和售后服务。
            </div>
            <div>
              4.2 您在使用 英博云
              平台上的服务时须遵守相关法律法规及服务规则，并确保拥有法律法规要求的经营资质和能力，不得实施包括但不限于以下行为，也不得为任何违反法律法规的行为提供便利，否则
              英博云有权对账号进行封禁并追究您对 英博云造成的法律损失：
            </div>
            <div>4.2.1 反对宪法所规定的基本原则的。 </div>
            <div>
              4.2.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。
            </div>
            <div> 4.2.3 损害国家荣誉和利益的。 </div>
            <div> 4.2.4 煽动民族仇恨、民族歧视，破坏民族团结的。 </div>
            <div>4.2.5 破坏国家宗教政策，宣扬邪教和封建迷信的。 </div>
            <div>4.2.6 散布谣言，扰乱社会秩序，破坏社会稳定的。 </div>
            <div>
              4.2.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的。
            </div>
            <div>4.2.8 侮辱或诽谤他人，侵害他人合法权益的。 </div>
            <div>4.2.9 实施任何违背“七条底线”的行为。 </div>
            <div>4.2.10 含有法律、行政法规禁止的其他内容的。 </div>
            <div>
              4.3 您在使用 英博云
              平台上的服务时须维护互联网秩序和安全，不得侵犯任何主体的合法权益，不得实施包括但不限于以下行为，也不得为其提供便利：
            </div>
            <div>
              4.3.1
              实施诈欺、虚伪不实或误导行为，或实施侵害他人知识产权等任何合法权益的行为，如“私服”、“外挂”等。
            </div>
            <div>
              4.3.2
              发布、传播垃圾邮件(SPAM)或包含危害国家秩序和安全、封建迷信、淫秽、色情、低俗等违法违规信息。
            </div>
            <div>
              4.3.3 违反与 英博云
              网络相联通之网络、设备或服务的操作规定；实施违法或未授权之接取、盗用、干扰或监测。
            </div>
            <div>
              4.3.4
              实施任何破坏或试图破坏网络安全的行为，包括但不限于以病毒、木马、恶意代码、钓鱼等方式，对网站、服务器进行恶意扫描、非法侵入系统、非法获取数据等。
            </div>
            <div>
              4.3.5 实施任何改变或试图改变 英博云
              服务提供的系统配置或破坏系统安全的行为；利用技术或其他手段破坏、扰乱
              英博云 服务的运营或他人对 英博云
              服务的使用；以任何方式干扰或企图干扰 英博云
              任何产品或任何部分、功能的正常运行，或者制作、发布、传播上述工具、方法等。
            </div>
            <div>
              4.3.6 因从事包括但不限于“DNS
              解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致您自己频繁遭受攻击(包括但不限于
              DDoS 攻击)且未及时更正行为，或未根据 英博云 要求消除影响，从而对
              英博云 服务平台或他人产生影响的。
            </div>
            <div>4.3.7 实施其他破坏互联网秩序和安全的行为。 </div>
            <div class="title">
              4.4
              您应当按照服务规则及时、足额支付费用。若您未及时、足额支付费用的，
              英博云
              有权拒绝开通服务或无需另行通知而中止、终止服务，同时可以采取以下一项或多项措施：
            </div>
            <div class="title">
              4.4.1
              要求您除应依约支付应付费用外，每逾期一天，还应按所欠费用1%的标准向
              英博云 支付违约金，直至缴清全部费用为止。
            </div>
            <div class="title">
              4.4.2 若您逾期付款超过15天， 英博云
              有权无需另行通知您即可随时采取包括但不限于提前单方解除协议的措施。
            </div>
            <div class="title">
              4.4.3
              若您逾期付款但您使用了预付费服务或您账号有未消耗的现金余额的，则
              英博云
              有权无需另行通知您，而直接将预付费用和现金余额用于抵扣拖欠款项和违约金。
            </div>
            <div class="title">
              4.4.4 删除您基于使用 英博云
              服务而存储或产生的部分或全部信息和数据。
            </div>
            <div class="title m-10">第五条 英博云 权利义务</div>
            <div>
              5.1 英博云 应当依照本协议约定向您提供 英博云 服务和售后支持。
            </div>
            <div>
              5.2 英博云 仅对 英博云
              服务本身提供运营维护，您应当保证自身的网络、设备的安全性、稳定性，如发生以下情况，您应及时解决并避免对
              英博云 服务产生影响：
            </div>
            <div>5.2.1 您内部网络出现问题，包括但不限于超负荷等。</div>
            <div> 5.2.2 您自有设备或您使用的第三方设备出现故障。 </div>
            <div>5.2.3 您自行拆离设备或通过其他方式导致网络中断。</div>
            <div> 5.2.4 其他您自身原因导致的任何故障、网络中断等。</div>
            <div class="title">
              5.3 若英博云
              自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反相关法律法规或本协议的行为的，
              英博云
              有权根据一般人的认识自行独立判断，并随时单方采取以下措施中的一种或多种：
            </div>
            <div class="title"> 5.3.1 要求您立即删除、修改相关内容。 </div>
            <div class="title">
              5.3.2 限制、暂停向您提供全部或部分 英博云
              服务(包括但不限于直接对您的部分服务进行下线并收回相关资源、对您账号采取操作限制/账号冻结等措施)。
            </div>
            <div class="title">
              5.3.3 终止向您提供 英博云
              服务，终止协议(包括但不限于直接对您的全部服务进行下线并收回相关资源等)。
            </div>
            <div class="title">
              5.3.4 英博云
              根据本协议终止向您提供服务或终止协议的，您预缴的费用将作为违约金归
              英博云 所有。
            </div>
            <div class="title">
              5.3.5 依法追究您的其他责任。 英博云
              依据本协议采取相应措施(包括但不限于暂停服务、扣除费用、终止协议等)，不视为
              英博云
              违约，若因此给您造成损失(包括但不限于业务暂停、数据清空等)的，均由您自行承担。因您违反本协议约定产生的责任和后果由您自行承担，若给
              英博云 或第三方造成损失的，您应当予以赔偿。
            </div>
            <div class="title">
              5.4 为合理保护您、您的用户及权利人等各方的利益， 英博云
              有权制定专门的侵权、投诉流程制度，您应当予以遵守。如果 英博云
              接到第三方对您的投诉或举报，英博云
              有权向第三方披露您相关资料(如您的主体资料及您就投诉或举报提交的反通知书、相关证据等全部资料)，要求您与投诉方进行协商(包括但不限于建立包含您、
              英博云
              以及投诉方的三方邮件组，供您、投诉方直接沟通、相互举证等，下同)，若您投诉或举报其他
              英博云 客户的， 英博云
              也有权向被投诉方披露您相关资料(如您的主体资料及您就投诉或举报提交的通知书、相关证据等全部资料)，要求您与被投诉方进行协商，以便及时解决投诉、纠纷，保护各方合法权益，您应当予以配合，否则，可能会影响您继续使用
              英博云 服务，由此造成您或他方损失的，您自行承担。
              <div class="title m-10">第六条 客户数据</div>
            </div>
            <div class="title">
              6.1 您保证，您存储、上传到 英博云 服务中，或者利用 英博云
              服务以分析、分发等任何方式处理的数据，为您依法收集、获取或产生的数据，您不会也不曾以任何方式侵犯任何个人或实体的合法权利。
            </div>
            <div class="title">
              6.2 您保证其有权使用 英博云
              服务对前述数据进行存储、上传、分析和分发等任何处理，且前述处理活动均符合相关法律法规的要求，不存在任何违法、侵权或违反其与第三方的合同约定的情形，不会将数据用于违法违规目的。
            </div>
            <div class="title">
              6.3 您有权自行使用 英博云
              服务对数据进行上传、分析、删除、更改等处理(具体以您使用的服务的服务规则为准)，就数据的删除、更改等处理，您应谨慎操作并承担因该等操作所产生的后果。
            </div>
            <div class="title">
              6.4 除因您使用 英博云 服务所需及法律法规另有规定外，未经您同意，
              英博云 不会接触或使用您的数据。
            </div>
            <div class="title">
              6.5 您应根据自身需求自行对数据进行备份， 英博云
              仅依据相关法律法规要求或服务规则约定提供数据备份服务， 英博云
              仅在法定或约定提供的数据备份服务的范围内承担责任。
            </div>
            <div class="title">
              6.6
              因您的数据的产生、收集、处理、使用等任何相关事项存在违反法律法规等情况而造成的全部结果及责任均由您自行承担，并且，
              英博云 有权随时全部或部分终止向您提供英博云
              服务。您因此遭受的一切损失或承担的一切责任和费用，由您自行承担。
            </div>
            <div class="title m-10">第七条 出口管制与制裁法律合规</div>
            <div>
              各方承诺遵守所有适用的经济与贸易制裁以及出口管制法律法规，包括所有由联合国安全理事会、中国、美国及任何其他国家所制定并执行的制裁决议、法律与法规以及出口管制法律与法规(在前述文件适用于该方的范围内)(下称“适用出口管制法律”)。您承诺不会将
              英博云
              提供的产品或服务用于适用出口管制法律所禁止的用途。非经相关主管机关许可，您及您授权使用
              英博云 提供的产品或服务的个人或实体不会通过 英博云
              提供的产品或服务向所适用出口管制法律所制裁或指定的个人或实体提供受控的技术、软件或服务，或以任何方式使得
              英博云 违反适用出口管制法律。
            </div>
            <div class="title m-10">第八条 责任限制</div>
            <div class="title">
              8.1 您理解并同意，在使用 英博云
              服务的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，
              英博云 应及时与相关单位配合进行修复，但是由此给您造成的损失 英博云
              将予以免责。
            </div>
            <div class="title">
              8.1.1
              不可抗力，包括但不限于自然灾害、政府行为、法律法规颁布调整、罢工(任一方内部劳资纠纷除外)、动乱等不能预见、不能避免并不能克服的客观情况。
            </div>
            <div class="title">
              8.1.2
              基础运营商原因，包括但不限于电信部门技术调整、电信/电力线路被他人破坏、电信/电力部门对电信网络/电力资源进行安装、改造、维护。
            </div>
            <div class="title">
              8.1.3
              网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏。
            </div>
            <div class="title">
              8.1.4 您通过非 英博云 授权的方式使用 英博云
              服务，您操作不当或您的电脑软件、系统、硬件和通信线路出现故障。
            </div>
            <div class="title">
              8.1.5 其他非 英博云 过错、 英博云 无法控制或合理预见的情形。
            </div>
            <div class="title">
              8.2
              因不可抗力、基础运营商原因、网络安全事故或其他超出当事人可合理掌控范围的事件，造成本协议迟延履行或任何一方违约，双方均无需承担违约责任。但是，受影响一方应尽可能及时通知另一方。如前述事件妨碍协议履行达30天以上的，任一方可提前15天书面通知对方终止协议。因本条款终止协议的，任何一方均无须承担违约责任。
            </div>
            <div class="title">
              8.3 您理解并同意，英博云
              的服务是按照现有技术和条件所能达到的现状提供的。 英博云
              将尽最大努力确保服务的连贯性和安全性，但 英博云
              不能保证其所提供的服务毫无瑕疵，因此，即使 英博云
              提供的服务存在瑕疵，但若上述瑕疵是当时行业技术水平所无法避免的，其将不视为
              英博云 违约， 英博云
              也无需承担任何责任，双方应友好协作共同解决问题。
            </div>
            <div class="title">
              8.4
              于任何情形下，任一方均不对另一方之任何间接的、偶然的、特殊的或惩罚性的损害和损失(如利润损失、机会损失、向第三方支付的费用、声誉/商誉损失或损害等)承担责任，无论基于合同、保证、侵权或任何其他责任理论，不论任一方是否知道或应当知道上述损失或损害的可能性。
            </div>
            <div class="title">
              8.5 于任何情形下，英博云 基于本协议及相关订单和 英博云
              服务向您所承担的赔偿责任(无论基于合同、侵权或任何其他责任理论)的总额，不超过您就造成您损失的
              英博云 服务已经向 英博云 支付的费用总额；如果造成您损失的相应
              英博云 服务的服务期限超过12个月的，则 英博云
              的最大赔偿责任不超过损害发生前12个月，您就造成您损失的 英博云
              服务已经向 英博云
              支付的费用总额(为免歧义，本处费用指您就实际使用该服务的时长/数量等而实际已支付的现金，不包括代金券、预付但未实际消耗的费用等)。若本条款与双方其他约定或
              英博云 服务规则冲突或不一致的，以本条约定为准。
            </div>
            <div class="title m-10">第九条 通知和送达</div>
            <div>
              9.1
              您应当保证和维持客户资料(包括但不限于电话号码、电子邮箱等联系方式)的有效性，客户资料若存在虚假、无效等任何可能导致您无法及时获悉业务通知、服务提示、客户服务、技术支持、纠纷协调、违规处罚等信息的，由您自行承担相应责任。
            </div>
            <div>
              9.2 您应当根据 英博云 官网公布的 英博云 的联系方式向 英博云
              发送通知，双方另有约定除外。
            </div>
            <div>
              9.3 英博云
              可通过网页公告、系统通知、站内信、电子邮件、手机短信、即时通讯工具、函件等方式中的一种或多种向您发送与
              英博云
              服务有关的业务通知、服务提示、验证消息、营销信息等各种信息(包括但不限于更新后的服务规则、服务升级、机房裁撤、广告等)。前述信息在以下情况下视为已送达：
            </div>
            <div>9.3.1 交专人递送的，在收件人签收时视为已送达。</div>{" "}
            <div>
              9.3.2 以网页公告等形式公布的，一经公布即生效(另有说明除外)。
            </div>
            <div>
              9.3.3
              以电子形式(包括系统通知、站内信、电子邮件、手机短信、即时通讯工具等)发送的，在发送成功后视为已送达。
            </div>
            <div>
              9.3.4
              以邮资预付的快递公司递送或以挂号信递送的，以投邮后的第3个自然日视为已送达。
              如果送达时间为法定节假日的，则以送达后首个工作日为送达日。
              <div class="title m-10">第十条 法律适用及争议解决</div>
            </div>
            <div class="title">
              10.1
              本协议的成立、生效、履行、解释及纠纷解决等，均适用中国大陆法律法规(不包括冲突法)。
            </div>
            <div class="title">
              10.2
              因本协议产生之争议，双方应首先协商解决；双方未能协商解决的，任何一方均应将争议提交本协议签订地有管辖权的人民法院裁决。双方无争议的部分，应当继续履行。
            </div>
            <div class="title m-10">第十一条 其他</div>
            <div>
              11.1
              除非另有说明，本协议正文及其附件中所有的“天”均为自然日，结算货币均为人民币。
            </div>
            <div>
              11.2
              本协议的拟定、解释均以中文为准。除双方另有约定外，任何有关本协议的翻译不得作为解释本协议或判定双方当事人意图之依据。
            </div>
            <div class="title">
              11.3
              服务规则为本协议的重要组成部分，与本协议正文具有同等法律效力，您应当予以遵守。
            </div>
          </p>);
            }
        }
    };
    return {
        agreeContent
    };
};
